/**
 * Canonical destinations for the unified AI Agents workspace.
 *
 * WHY THIS EXISTS — Live Chat moved into the workspace (`/home/ai-agents`, which
 * renders `AiAgentsWorkspace` and scopes itself off `?type=`). The sidebar was
 * repointed at the time; the two Live Chat entry points on the `/home` dashboard
 * were not, so they kept sending people to the legacy `/home/live-chat` channels
 * list — the "old UI" report. A shared constant is what stops the next surface
 * from drifting the same way; `aiAgentsRoutes.test.ts` asserts it still matches
 * the URL the sidebar actually uses.
 *
 * ⚠️ `/home/live-chat` IS STILL A LIVE ROUTE and must stay reachable: it owns the
 * only validated channel create/edit/delete flow (required website URL, URL
 * normalisation, and the duplicate-name guard the live-chat microservice cannot
 * enforce itself — see the route comment in App.tsx). Do NOT sweep the remaining
 * references to it out of the permission path lists, the legacy pages' own
 * internal navigation, or `AgentChannelsPanel`'s "manage channels" action. Only
 * surfaces that mean "take me to Live Chat" belong on the constant below.
 */

/** The workspace itself — all agent types. */
export const AI_AGENTS_WORKSPACE_PATH = '/home/ai-agents';

/**
 * Live Chat inside the workspace. `?type=general` is the live-chat scope (the
 * sidebar labels exactly this URL "Live Chat").
 *
 * Safe to link unconditionally: the workspace coerces `?type=` against the types
 * the user is actually allowed to see, so a plan without the entitlement lands on
 * a scope it can see rather than a permanently empty grid.
 */
export const LIVE_CHAT_WORKSPACE_PATH = '/home/ai-agents?type=general';

/** The legacy channels list. Still routed — see the warning above. */
export const LEGACY_LIVE_CHAT_CHANNELS_PATH = '/home/live-chat';
